import React from 'react';
import { Box, Typography, Button, SxProps, Theme } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: SvgIconComponent;
  action?: {
    label: string;
    onClick: () => void;
  };
  sx?: SxProps<Theme>;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon: Icon,
  action,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        p: 4,
        width: '100%',
        minHeight: 200,
        textAlign: 'center',
        ...sx,
      }}
    >
      {Icon && (
        <Icon
          sx={{
            fontSize: 48,
            color: 'text.secondary',
            mb: 2,
          }}
        />
      )}
      <Typography
        variant="h6"
        color="text.primary"
        sx={{ mb: description || action ? 1 : 0 }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: action ? 2 : 0, maxWidth: 320 }}
        >
          {description}
        </Typography>
      )}
      {action && (
        <Button variant="contained" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
